<template>
  <div class="check-list">
    <el-table
      ref="multipleTable"
      :data="checkList"
      tooltip-effect="dark"
      style="width: 100%"
      class="common-edit-button"
    >
      <el-table-column
        prop="typeName"
        label="值日类型"
        :show-overflow-tooltip="true"
        width="150px"
      >
      </el-table-column>
      <el-table-column
        prop="showOrder"
        label="显示顺序"
        :show-overflow-tooltip="true"
        width="100px"
      >
      </el-table-column>
      <el-table-column
        prop="dutyArea"
        label="值日范围"
        :show-overflow-tooltip="true"
        width="150px"
      >
        <template slot-scope="scope">
          {{
            dutyAreaList.length
              ? dutyAreaList.find(
                  (item) => item.dictValue == scope.row.dutyArea
                ).dictLabel
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否首页展示"
        :show-overflow-tooltip="true"
        width="150px"
      >
        <template slot-scope="scope">
          {{ scope.row.status == "1" ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="periodList"
        label="值日时间"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.periodList.length">未设置</span>
          <span
            v-else
            v-for="(item, index) in scope.row.periodList"
            :key="index"
          >
            {{ item.startTime + "-" + item.endTime }}<br />
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button
              type="warning"
              size="small"
              icon="el-icon-edit"
              @click="editType(scope.row)"
              >修改
            </el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="delType(scope.row)"
              >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改 -->
    <editTypeDialog
      :dialogVisible.sync="editTypeShow"
      :typeInfo="typeInfo"
      :dutyAreaList="dutyAreaList"
      :isShowList="isShowList"
      v-show="editTypeShow"
    />
  </div>
</template>

<script>
import editTypeDialog from "../type-edit/type-edit.vue";
export default {
  data() {
    return {
      // selectList: [],
      typeInfo: null,
      editTypeShow: false,
    };
  },
  props: {
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dutyAreaList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isShowList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    editTypeDialog,
  },
  inject: ["refresh"],
  created() {},
  methods: {
    delType(item) {
      this.$confirm("是否删除该值日类型?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(this.$url.deleteDutyTypeById + "?id=" + item.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败，请稍后重试");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    editType(item) {
      this.editTypeShow = true;
      this.typeInfo = item;
    },
  },
};
</script>

<style>
@import "./checkList.scss";
</style>
